import React, { useState, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const EditAssignmentModal = ({ assignment, onClose, onSave, onDelete, projects }) => {
  const [editedAssignment, setEditedAssignment] = useState({
    id: assignment.id,
    project: assignment.project,
    resource_type: assignment.resource_type,
    resource_id: assignment.resource_id,
    start: moment(assignment.start_date).format('YYYY-MM-DD'),
    end: moment(assignment.end_date).format('YYYY-MM-DD'),
    type: assignment.type,
    color: assignment.color,
    comment: assignment.comment
  });

  useEffect(() => {
    console.log('Initial editedAssignment:', editedAssignment);
  }, []);

  const defaultColors = {
    project: '#3498db',
    holiday: '#34495e',
    day_off: '#f39c12',
    travel: '#95a5a6'
  };

  useEffect(() => {
    if (editedAssignment.type === 'project') {
      const selectedProject = projects.find(p => p.id === editedAssignment.project);
      setEditedAssignment(prev => ({
        ...prev,
        color: selectedProject?.color || defaultColors.project
      }));
    } else {
      setEditedAssignment(prev => ({
        ...prev,
        color: defaultColors[prev.type] || defaultColors.project
      }));
    }
  }, [editedAssignment.type, editedAssignment.project, projects]);

  const handleSave = () => {
    const updatedAssignment = {
      ...editedAssignment,
      start_date: moment(editedAssignment.start).format('YYYY-MM-DD'),
      end_date: moment(editedAssignment.end).format('YYYY-MM-DD'),
    };
    console.log('Sending updated assignment from modal:', updatedAssignment);
    onSave(updatedAssignment);
    onClose();
  };


  const handleDelete = () => {
    onDelete(assignment.id);
    onClose();
  };

  const handleTypeChange = (e) => {
    const newType = e.target.value;
    setEditedAssignment(prev => ({
      ...prev,
      type: newType,
      project: newType === 'project' ? (projects[0]?.id || '') : '',
      comment: newType === 'project' ? prev.comment : '',
      color: newType === 'project' 
        ? (projects.find(p => p.id === prev.project)?.color || defaultColors.project)
        : (defaultColors[newType] || defaultColors.project)
    }));
  };

  const handleProjectChange = (e) => {
    const selectedProjectId = Number(e.target.value);
    const selectedProject = projects.find(p => p.id === selectedProjectId);
    setEditedAssignment(prev => ({
      ...prev,
      project: selectedProjectId,
      color: selectedProject?.color || defaultColors.project
    }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Edit Assignment</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Assignment Type</label>
          <select
            value={editedAssignment.type}
            onChange={handleTypeChange}
            className="select w-full"
          >
            <option value="project">Work</option>
            <option value="holiday">Holiday</option>
            <option value="day_off">Day Off</option>
            <option value="travel">Travel</option>
          </select>
        </div>
        {editedAssignment.type === 'project' && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Project</label>
            <select
              value={editedAssignment.project}
              onChange={handleProjectChange}
              className="select w-full"
            >
              {projects && projects.length > 0 ? (
                projects.map(project => (
                  <option key={project.id} value={project.id}>
                    {project.name}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  Loading Projects...
                </option>
              )}
            </select>
          </div>
        )}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Color</label>
          <div 
            className="w-full h-10 rounded border border-gray-300"
            style={{ backgroundColor: editedAssignment.color }}
          ></div>
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Comment</label>
          <textarea
            value={editedAssignment.comment}
            onChange={(e) => setEditedAssignment({ ...editedAssignment, comment: e.target.value })}
            className="input w-full"
            placeholder="Enter a comment"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <input
            type="date"
            value={editedAssignment.start}
            onChange={(e) => setEditedAssignment({ ...editedAssignment, start: e.target.value })}
            className="input w-full"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <input
            type="date"
            value={editedAssignment.end}
            onChange={(e) => setEditedAssignment({ ...editedAssignment, end: e.target.value })}
            className="input w-full"
          />
        </div>
        <div className="flex justify-end space-x-2">
          <button onClick={handleSave} className="btn btn-blue">Save</button>
          <button onClick={handleDelete} className="btn btn-red">Delete</button>
          <button onClick={onClose} className="btn btn-gray">Cancel</button>
        </div>
      </div>
    </div>
  );
};

EditAssignmentModal.propTypes = {
  assignment: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  projects: PropTypes.array.isRequired,
};

export default EditAssignmentModal;